import { ComponentStyleConfig } from '@chakra-ui/react';

export const EmptyList: ComponentStyleConfig = {
  baseStyle: (hasOverride) => ({
    title: {
      fontWeight: 500,
      paddingTop: 6,
      fontSize: 'lg',
      textAlign: 'center',
      lineHeight: 'normal',
      letterSpacing: '0.5px',
      wordBreak: 'break-word',
    },
    text: {
      maxWidth: '536px',
      textAlign: 'center',
      paddingTop: 1,
      color: !hasOverride ? 'textSubdued' : 'textSubdued',
      fontSize: 'md',
      lineHeight: 'normal',
      wordBreak: 'break-word',
    },
    icon: {
      '& svg': {
        width: '96px',
        height: '96px',
        color: 'P.50',
      },
    },
  }),
  sizes: {},
  defaultProps: {},
};
